import { Alert as AntAlert } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import styled from 'styled-components';

export const ToolBarContainer = styled.div`
  background: #f7f7f7;
  border-top: 1px solid #c9c9c9;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const ToolBarRight = styled.div`
  display: inline-flex;
  gap: 8px;
`;

export const ToolBarLeft = styled.div`
  display: inline-flex;
  gap: 8px;
`;

export const StyledAntAlert = styled(AntAlert)<AlertProps>`
  &.emp-ant-alert-warning {
    border: none;
    background-color: #fff9f2;
    border-radius: 4px;
    padding: 4px 8px;
  }

  & {
    .emp-ant-alert-warning {
      font-size: 16px;
      width: 20px;
      height: 200px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .emp-ant-alert-content {
      letter-spacing: -0.01em;
    }

    .emp-ant-alert-message {
      color: #ff9300;
      font-weight: 500;
      height: 20px;
      line-height: 20px;
    }
  }
`;
